<template>
  <VModal
    :is-open="isOpen"
    is-center
    @close="closeModal"
  >
    <template #title>
      {{ $t("Setup.WelcomeTitle") }}
    </template>

    <template #body>
      <img
        :src="require('../../../assets/abeja_logo.png')"
        class="rounded mx-auto d-block logo-image"
      >
      <p
        class="welcome-message"
        v-html="$t('Setup.WelcomeMessage')"
      />
    </template>

    <template #footer>
      <button
        type="button"
        class="btn btn-outline-secondary btn-lg font-weight-bold"
        @click="closeModal"
      >
        {{ $t("Setup.Button.Back") }}
      </button>
      <button
        type="button"
        class="btn btn-primary btn-lg"
        @click="finishSetup"
      >
        {{ $t("Setup.Button.GoDashboard") }}
      </button>
    </template>
  </VModal>
</template>

<script>
import VModal from '@/components/VModal.vue'

export default {
  components: {
    VModal
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:is-open', false)
    },
    finishSetup() {
      this.$emit('update:is-open', false)
      this.$router.push({ name: 'SmartScheduling' })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@abeja-inc/abeja-ui-library/scss/_variables.scss";

.logo-image {
  width: 10vw;
  height: auto;
  max-width: 100px;
}
.welcome-message {
  font-size: $font-size-lg-1;
  margin: 16px 0;
  white-space: pre-line;
}
</style>
